/*
 *
 * internalstore Actions
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 22-May-2024
 */

import { createAction } from './index'

export const actionTypes = {
  STATUS_IDLE: 'internalstore/status_idle',
  STATUS_FAILURE: 'internalstore/status_failure',
  DO_TOGGLE_SIDEBAR: '@@internalstore/toggle_sidebar'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action
 * * Insert a description
 * @name StatusIdle
 * @return {object} - The payload object
 */
export const doStatusIdle = (payload) => createAction(actionTypes.STATUS_IDLE, { payload })

/** @action
 * * Insert a description
 * @name StatusFailure
 * @return {object} - The payload object
 */
export const doStatusFailure = (payload) => createAction(actionTypes.STATUS_FAILURE, { payload })

// @generator action
/** @action
 * * Insert a description
 * @name ToggleSidebar
 * @return {object} - The payload object
 */
export const doToggleSidebar = (payload) => createAction(actionTypes.DO_TOGGLE_SIDEBAR, { payload })
